import React, { useState } from 'react';
import { X, Send } from 'lucide-react';

export const AdminChatModal = ({ onClose }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput]       = useState('');

  const sendMessage = async () => {
    if (!input.trim()) return;
    const newMsg = { role: 'user', content: input };
    setMessages(prev => [...prev, newMsg]);
    setInput('');
    try {
      const response = await fetch(`${window.location.origin}/api/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: input,
          session_id: `admin_${Date.now()}`,
          is_admin: true,
          conversation_history: messages
        })
      });
      const data = await response.json();
      setMessages(prev => [...prev, { role: 'assistant', content: data.response }]);
    } catch {
      setMessages(prev => [...prev, { role: 'assistant', content: '❌ Erreur de communication' }]);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl w-full max-w-3xl h-[600px] flex flex-col">
        <div className="p-4 border-b flex justify-between items-center">
          <div>
            <h3 className="text-xl font-bold">💬 Chat avec le Bot (Mode Admin)</h3>
            <p className="text-sm text-gray-600">Le bot sait que vous êtes admin et va apprendre</p>
          </div>
          <button onClick={onClose}><X size={24} /></button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 space-y-4">
          {messages.length === 0 && (
            <div className="text-center text-gray-400 mt-20">
              <p>Parlez au bot pour lui donner des instructions</p>
              <p className="text-sm mt-2">Ex: "Désormais, on répare aussi les MacBook Pro"</p>
            </div>
          )}
          {messages.map((msg, idx) => (
            <div key={idx} className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}>
              <div className={`max-w-[70%] rounded-2xl px-4 py-2 ${
                msg.role === 'user' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-800'
              }`}>
                {msg.content}
              </div>
            </div>
          ))}
        </div>
        <div className="p-4 border-t flex space-x-2">
          <input
            type="text" value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && sendMessage()}
            className="flex-1 border rounded-lg px-4 py-2"
            placeholder="Donnez des instructions au bot..."
          />
          <button onClick={sendMessage} className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg">
            <Send size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};
